import { GlSprintf, GlLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'NoteSignedOutWidget',
    components: {
        GlSprintf,
        GlLink
    },
    signedOutPhrase: {
        message: __('Please %{startTagRegister}register%{endRegisterTag} or %{startTagSignIn}sign in%{endSignInTag} to reply'),
        placeholders: {
            register: [
                'startTagRegister',
                'endRegisterTag'
            ],
            signIn: [
                'startTagSignIn',
                'endSignInTag'
            ]
        }
    },
    inject: {
        endpoints: {
            type: Object
        }
    }
};
